import worldMerc from "./worldMerc.json";
import worldMill from "./worldMill.json";
export { worldMerc, worldMill };
//# sourceMappingURL=index.js.map